import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "@emotion/styled";
import Auth from "lib/auth";

import {
  useGenerateResetPasswordTokenMutation,
  useLoginMutation,
  useResetPasswordMutation,
} from "generated/graphql";
import AuthHeader from "components/auth/AuthHeader";
import InputField from "components/auth/InputField";
import { AuthFormWrapper, Error } from "components/auth/shared";

interface ResetPasswordFormValues {
  email: string;
  password: string;
  confirmPassword: string;
}

const RegistrationForm = styled.form``;

const auth = new Auth();

function SetNewPasswordPage() {
  const [message, setMessage] = useState<{
    text: string;
    success: boolean;
  } | null>(null);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Fetch generated token from query params
  const query = new URLSearchParams(useLocation().search);
  const token = query.get("token");

  // Mutations
  const [resetPasswordMutation, { loading, error: err }] = useResetPasswordMutation();
  const [
    loginMutation,
    { data: loginData, loading: loginLoading, error: loginError },
  ] = useLoginMutation();

  // Validation Util
  const eitherFieldIsEmpty = () => password === "" || confirmPassword === "";

  const validate = () => {
    const errors: { confirmPassword?: string; password?: string } = {};
    if (confirmPassword && password) {
      if (password !== confirmPassword) {
        Object.assign(errors, { confirmPassword: "Password do not match" });
      }
      if (password.length < 6) {
        Object.assign(errors, { password: "Password too short" });
      }
    }
    return errors;
  };

  const handleSubmit = () => {
    const isEmpty = eitherFieldIsEmpty();
    if (!isEmpty && token) {
      resetPasswordMutation({
        variables: {
          input: {
            email,
            newPassword: password,
            token,
          },
        },
      })
        .then((res) => {
          console.log({ res });
          setMessage({ text: "Password updated successfully", success: true });
          return loginMutation({
            variables: {
              input: {
                email,
                password,
              },
            },
          });
        })
        .catch((err) => {
          console.error(err);
          setMessage({
            text: loginError?.message || "Password updated failed",
            success: false,
          });
        });
    }
  };

  if (loginData?.login) {
    auth.login({
      token: loginData.login.accessToken,
    });
  }

  return (
    <>
      <AuthHeader />
      <AuthFormWrapper>
        <h1>Enter your new Jiwe eSports Password</h1>
        {err && err.message && <Error>{err.message}</Error>}
        <RegistrationForm
          onSubmit={(e) => {
            e.preventDefault();
            validate();
            handleSubmit();
          }}
        >
          <InputField
            setValue={setEmail}
            value={email}
            placeholder="name@email.com"
            type="email"
            name="email"
            label="Confirm your email address"
            className="input-box"
          />
          <InputField
            setValue={setPassword}
            value={password}
            placeholder="6+ Characters"
            type="password"
            name="password"
            label="Password"
            className="input-box"
          />
          <InputField
            setValue={setConfirmPassword}
            value={confirmPassword}
            placeholder="Confirm Password"
            type="password"
            name="password"
            label="Password"
            className="input-box"
          />
          <button
            type="submit"
            className="btn"
            disabled={loading || loginLoading}
          >
            Set new password
          </button>
          <br />
        </RegistrationForm>
      </AuthFormWrapper>
    </>
  );
}

export default SetNewPasswordPage;
